import { Deal } from "@Types/deal";
import { Metadata } from "@Types/documents";
import { Priority } from "@Types/tickets";

export enum States {
  Welcome = "welcome",
  WelcomeLoan = "welcome_loan",
  LoanIssue = "loan_issue",
  LoanFound = "loan_found",
  TitleIssue = "title_issue",
  Priority = "priority",
  Participant = "participant",
  OtherIssue = "other_issue",
  Submit = "submit",
  End = "end",
}

export interface Component {
  (props: CommonProps): JSX.Element;
}
export interface SelectedOptionComponent {
  ({ deal }: { deal?: Deal }): JSX.Element;
}
export interface CommonProps {
  index?: number;
  state: TicketState;
  setState: React.Dispatch<React.SetStateAction<TicketState>>;
  setText: React.Dispatch<React.SetStateAction<string>>;
  text: string;
}

export interface InteractionProps {
  prevState: TicketState;
  optionIndex: number;
  currentState: States;
  setState: React.Dispatch<React.SetStateAction<TicketState>>;
}
export type Option = {
  type?: "next" | "submit";
  title?: string;
  onClick?: (props: InteractionProps) => void;
  next: States;
  component?: Component;
  selectedOptionComponent?: SelectedOptionComponent;
};

export type TicketFile = { name: string; url: string; metadata: Metadata };

export type TicketFormData = {
  deal: Deal | null;
  isTitleIssue: boolean;
  description: string | null;
  priority: Priority | null;
  participant: string | null;
  files: TicketFile[];
};

type TicketSource = "dashboard" | "deal";

export type TicketState = {
  type: TicketSource;
  ticketData: TicketFormData;
  name: States;
} & State;

export type ChatTextData = "description" | "participant";
type State = {
  inProgress?: boolean;
  isInput?: boolean;
  dataName?: ChatTextData;
  messages: string[];
  stateComponent?: SelectedOptionComponent;
  options: Option[];
  previousState?: TicketState;
  selectedOption?: Option;
};

export interface AdditionalProps {
  deal?: Deal;
  description?: string;
  participant?: string;
  files?: TicketFile[];
}
export interface InteractionProps extends AdditionalProps {
  optionIndex: number;
  currentState: States;
  prevState: TicketState;
  setState: React.Dispatch<React.SetStateAction<TicketState>>;
}

export type MachineStates = Record<States, State>;
